import { render, staticRenderFns } from "./inspectionPoints.vue?vue&type=template&id=9c20f930&scoped=true&"
import script from "./inspectionPoints.vue?vue&type=script&lang=js&"
export * from "./inspectionPoints.vue?vue&type=script&lang=js&"
import style0 from "./inspectionPoints.vue?vue&type=style&index=0&id=9c20f930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c20f930",
  null
  
)

export default component.exports